export default "__VITE_ASSET__BWHupc7G__"